import React from 'react';

export default function LinkedInButton() {
  return (
    <a 
      href="https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=6922801319443394560" 
      target="_blank" 
      rel="noopener noreferrer"
      className="inline-flex flex-col justify-center px-[7px] text-center no-underline text-white w-[200px] h-[32px] rounded-[16px] bg-[#0A66C2] font-sans text-[14px] font-medium transition-transform hover:scale-105"
    >
      Subscribe on LinkedIn
    </a>
  );
}